export function initShowMoreLists(): void {
  document
    .querySelectorAll<HTMLElement>('[data-component="show-more-list"]')
    .forEach((list) => {
      const button = list.querySelector<HTMLButtonElement>(
        '[data-show-more-button]',
      );
      if (!button) return;

      const pageSize = Number(list.dataset.pageSize) || 4;
      // .btn sets display, which beats the [hidden] attribute on the button itself.
      const buttonContainer = button.parentElement ?? button;

      button.addEventListener('click', () => {
        const hiddenItems = list.querySelectorAll<HTMLElement>(
          '[data-show-more-item][hidden]',
        );
        const revealed = Array.from(hiddenItems).slice(0, pageSize);
        revealed.forEach((item) => (item.hidden = false));

        if (hiddenItems.length <= pageSize) {
          buttonContainer.hidden = true;
        }

        revealed[0]
          ?.querySelector<HTMLElement>('.article--preview__heading')
          ?.focus();
      });
    });
}
